import { Box, Stack, Button } from '@mui/material'
import type React from 'react'

import TrustedSourcesRequiredLabel from '@/components/TrustedSourcesRequiredLabel'

interface Props {
  buttonLabel: string
  disabled?: boolean
  onClick: () => void
  showTrustedSourcesRequiredLabel?: boolean
}

const TrustedSourcesFooter: React.FC<Props> = ({
  buttonLabel,
  disabled,
  onClick,
  showTrustedSourcesRequiredLabel,
}) => (
  <Box sx={{ pt: 2, borderTop: '1px solid #f2f2f2' }}>
    {showTrustedSourcesRequiredLabel && (
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="center"
        sx={{ mb: 1.5 }}
      >
        <TrustedSourcesRequiredLabel />
      </Stack>
    )}
    <Button
      variant="contained"
      fullWidth
      sx={{
        bgcolor: '#1B4554',
        '&:hover': { bgcolor: '#13323d' },
        textTransform: 'none',
        fontWeight: 600,
        py: 2,
      }}
      disabled={disabled}
      onClick={onClick}
    >
      {buttonLabel}
    </Button>
  </Box>
)

export default TrustedSourcesFooter
